import { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";
import { RefreshCw } from "lucide-react";

// Nouvelle version de Pipeline déployée pendant que l'onglet est ouvert (useVersionCheck, fourni par App) : un avis qui
// RESTE jusqu'au clic (Alex 2026-10-29 : « Has to be permanent… the normal notification fades »), placé là où il ne
// recouvre rien — en haut de la barre latérale sur ordinateur, dans l'en-tête sur téléphone (un bandeau par-dessus la
// page masquait le menu et les barres d'action, revue santa). Jamais de rechargement forcé ; des choix non enregistrés
// gardent l'alerte « quitter la page ? » des bureaux (beforeunload). Compact : la barre latérale était déjà trop haute sur
// un portable 1366×768 (elle défile désormais, overflow-y-auto).
export const StaleBuildContext = createContext(false);

export default function VersionNotice({ compact = false }) {
  const { t } = useTranslation();
  const stale = useContext(StaleBuildContext);
  if (!stale) return null;
  const reload = () => window.location.reload();
  if (compact) {
    // en-tête mobile : l'icône seule sous 360 px (le libellé déborderait à 320 px avec le déclencheur des tâches)
    return (
      <button type="button" onClick={reload} data-testid="version-notice-compact" title={t("versionCheck.description")}
        aria-label={t("versionCheck.reload")}
        className="ml-2 flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-violet-600 px-2.5 py-1 text-xs font-semibold text-white shadow-[0_0_0_3px_rgba(139,92,246,0.25)] hover:bg-violet-500">
        <RefreshCw className="h-3.5 w-3.5" aria-hidden="true" /><span className="hidden min-[360px]:inline">{t("versionCheck.reload")}</span>
      </button>
    );
  }
  return (
    <div data-testid="version-notice" title={t("versionCheck.description")}
      className="mb-4 space-y-1.5 rounded-xl border border-violet-500/60 bg-violet-600/15 px-3 py-2 text-xs text-violet-50 shadow-[0_0_0_3px_rgba(139,92,246,0.15)]">
      <p className="flex items-center gap-1.5 font-semibold"><RefreshCw className="h-3.5 w-3.5 shrink-0 text-violet-300" aria-hidden="true" />
        {t("versionCheck.title")}</p>
      <span className="sr-only">{t("versionCheck.description")}</span>
      <button type="button" onClick={reload} data-testid="version-notice-reload"
        className="w-full rounded-lg bg-violet-600 px-3 py-1 font-semibold text-white hover:bg-violet-500">{t("versionCheck.reload")}</button>
    </div>
  );
}
